module.exports = __webpack_public_path__ + "static/img/ph03.9529c5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/works/video-archive/ph03.jpg
// module id = ST+l
// module chunks = 0